<template>
	<Modal
		v-if="visible"
		:allow-close="false"
	>
		<template #body>
			<div class="flex flex-col items-center">
				<p :class="paragraphStyle">
					Hey there! Before you continue, we&apos;d love to get your
					feedback.
				</p>
				<div class="won-blue mt-6 text-base">
					Thank you for using the ResumAI! Please go to our survey
					to answer a couple questions to let us know how we can improve
					your experience.
				</div>
			</div>
		</template>

		<template #actions>
			<button
				:class="[buttonStyle]"
				@click="handleRedirect()"
			>
				Go to survey
			</button>
		</template>
	</Modal>
</template>

<script>
import Modal from '../components/modal.vue';

import { buttonStyle, paragraphStyle } from '../utils/styles';

export default {
	components: {
		Modal,
	},
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		link: {
			type: String,
			required: true,
		},
	},
	emits: ['survey-modal:close'],
	setup({ link }) {
		return {
			link,
		};
	},
	data: () => ({ buttonStyle, paragraphStyle }),
	methods: {
		handleRedirect() {
			window.open(this.link, '_blank');
			this.$emit('survey-modal:close');
		},
	},
};
</script>


